import { get } from 'lodash';

export default function isSpotifyPreAddsAvailable(filter) {
  const availableDate = new Date('2026-03-09');

  const start = get(filter, 'global.dateStart');
  const end = get(filter, 'global.dateEnd');

  if (!start || !end) {
    return {
      isAvailable: false,
      isPartialAvailability: false,
    };
  }

  const startDate = new Date(start);
  const endDate = new Date(end);

  return {
    isAvailable: endDate >= availableDate,
    isPartialAvailability: startDate < availableDate && endDate >= availableDate,
  };
}